'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Why 5 Ton?', href: '#why-5-ton' },
    { label: 'Models',     href: '#models' },
    { label: 'Installation', href: '#installation' },
    { label: 'Pricing',    href: '#pricing' },
    { label: 'FAQ',        href: '#faq' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'nav-blur shadow-navy-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5">
            <AppLogo
              size={36}
              text="Trane5Ton"
              iconName="FireIcon"
              className={`transition-colors duration-300 ${scrolled ? '' : 'brightness-0 invert'}`}
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-7">
            {navLinks?.map((l) => (
              <a
                key={l?.href}
                href={l?.href}
                className={`text-sm font-medium transition-colors duration-200 amber-link ${
                  scrolled ? 'text-navy' : 'text-white/85 hover:text-white'
                }`}
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
              >
                {l?.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <a
            href="#estimate"
            className="hidden md:inline-flex items-center gap-2 btn-primary px-5 py-2.5 rounded-xl text-sm"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 12l2 2 4-4"/>
              <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
            </svg>
            Free Estimate
          </a>

          {/* Mobile hamburger */}
          <button
            className={`md:hidden p-2 rounded-lg transition-colors ${scrolled ? 'text-navy' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {menuOpen
                ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                : <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>
              }
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`}>
          <div className="nav-blur border-t border-gray-100 px-5 py-4 flex flex-col gap-1">
            {navLinks?.map((l) => (
              <a
                key={l?.href}
                href={l?.href}
                onClick={() => setMenuOpen(false)}
                className="text-navy font-medium text-sm py-3 px-3 rounded-lg hover:bg-slate-light transition-colors"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
              >
                {l?.label}
              </a>
            ))}
            <a
              href="#estimate"
              onClick={() => setMenuOpen(false)}
              className="btn-primary mt-2 py-3 px-4 rounded-xl text-sm text-center"
            >
              Get Free Estimate
            </a>
          </div>
        </div>
      </header>
    </>
  );
}